import React from 'react';
import JsonView from '@uiw/react-json-view';

interface JsonMetadataViewerProps {
  data: Record<string, any>;
  className?: string;
  height?: string;
}

export function JsonMetadataViewer({ data, className = '', height = '300px' }: JsonMetadataViewerProps) {
  return (
    <div className={`rounded-md border ${className}`}>
      <JsonView 
        value={data}
        style={{
          background: 'transparent',
          padding: '1rem',
          height,
          overflow: 'auto',
        }}
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={true}
        shortenTextAfterLength={48}
      />
    </div>
  );
}
